import moment from "moment";
export function display_date(value, strFormat) {
  if(!value) return '';
  if(typeof value === 'string' || value instanceof String) {
    value = !value.includes('Z') ? value + 'Z' : value;
  }
  return moment(value).local().format(strFormat ? strFormat : 'DD-MM-YYYY HH:mm:ss');
}
import config from '../configs'
export function order_status(value, type = 0){
  const objStatus = type == 0 ? config.ORDER_STATUS.find(obj => obj.value === value) : config.ORDER_DEPOSIT_STATUS.find(obj => obj.value === value);
  return objStatus ? objStatus.name : '';
}

export function order_status_color(value, type = 0){
  const objStatus = type == 0 ? config.ORDER_STATUS.find(obj => obj.value === value) : config.ORDER_DEPOSIT_STATUS.find(obj => obj.value === value);
  return objStatus ? objStatus.color : 'black';
}

export function order_status_text_color(value, type = 0){
  const objStatus = type == 0 ? config.ORDER_STATUS.find(obj => obj.value === value) : config.ORDER_DEPOSIT_STATUS.find(obj => obj.value === value);
  return objStatus ? objStatus.textColor : 'black';
}

export function vip_level(value){
  const objRet = config.VIP_LEVEL.find(obj => obj.value === value);
  return objRet ? objRet.name : '';
}

export function vip_level_color(value){
  const objRet = config.VIP_LEVEL.find(obj => obj.value === value);
  return objRet ? objRet.color : '';
}

export function capitalize(value){
  return value.toLowerCase().replace(/^.|\s\S/g, function(a) { return a.toUpperCase(); });
};

export function display_value(value, enums, key_field = 'value', value_field = 'name') {
  const item = enums.find(obj => obj[key_field] === value);
  return item ? item[value_field] : '';
}

export function display_color(value, enums) {
  const item = enums.find(obj => obj.value === value);
  return item ? item.color : '';
}

export function display_text_color(value, enums) {
  const item = enums.find(obj => obj.value === value);
  return item ? item.textColor : '';
}

export function pad(value, size, prefix = '') {
  if(!value) {
    return '';
  }
  let val = value.toString();
  while (val.length < size) {
    val = "0" + val;
  }
  return prefix+val;
}